export default class Coordinates {
  constructor(data = {}) {
    this.latitude = data.latitude;
    this.longitude = data.longitude;
  }
}
